import { CommonModule, DatePipe } from '@angular/common';
import {
  Component,
  inject,
  Input,
  OnInit,
  Output,
  signal,
  WritableSignal,
} from '@angular/core';
import { TuiTable } from '@taiga-ui/addon-table';
import { TuiAppearance, TuiHint, TuiIcon } from '@taiga-ui/core';
import { TuiCheckbox, TuiChip, TuiComment } from '@taiga-ui/kit';
import { PatientTitleGroupComponent } from '../../patient-title-group/patient-title-group.component';
import { ObsPipe } from '../../pipes/obs.pipe';
import { ObsStatutPipe } from '../../pipes/obs-statut.pipe';
import { IahResiduelPipe } from '../../pipes/iah-residuel.pipe';
import { IahResiduelStatutPipe } from '../../pipes/iah-residuel-statut.pipe';
import { FuitesPipe } from '../../pipes/fuites.pipe';
import { FuitesStatutPipe } from '../../pipes/fuites-statut.pipe';
import { PressionPipe } from '../../pipes/pression.pipe';
import { DateEcheanceStatutPipe } from '../../pipes/date-echeance-statut.pipe';
import { Patient } from '../../models/patient';
import { Subscription, tap } from 'rxjs';
import { PatientService } from '../../services/patient.service';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-patient-row',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TuiTable,
    TuiIcon,
    TuiComment,
    DatePipe,
    CommonModule,
    TuiHint,
    PatientTitleGroupComponent,
    ObsPipe,
    ObsStatutPipe,
    IahResiduelPipe,
    IahResiduelStatutPipe,
    FuitesPipe,
    FuitesStatutPipe,
    PressionPipe,
    TuiIcon,
    DateEcheanceStatutPipe,
    TuiCheckbox,
    TuiAppearance,
    RouterLink,
    TuiChip,
  ],
  templateUrl: './patient-row.component.html',
  styleUrl: './patient-row.component.scss',
})
export class PatientRowComponent implements OnInit {
  @Input() patient: Patient | undefined;
  @Input() dosActiviteList: string[] = [];
  @Input() activite: string | undefined;
  @Input() signMass: boolean = false;
  @Input() libelleActivite: boolean = false;
  @Output() onClickSignMass = new EventEmitter<void>(); // Événement personnalisé

  private readonly patientService = inject(PatientService);
  readonly authService = inject(AuthService);

  private subscriptionChargementDonneePatient: Subscription | undefined;

  patient0: WritableSignal<Patient | undefined> = signal(undefined);
  enCoursDeChargement0: WritableSignal<boolean> = signal(false);
  acceptOrdonnance0: WritableSignal<boolean | undefined> = signal(undefined);

  isNumber(varTest: any): boolean {
    return typeof varTest == 'number';
  }

  number(varTest: any): number {
    return parseFloat(varTest);
  }

  check(id: number) {
    this.onClickSignMass.emit();
  }

  getVeille(date: Date | string | undefined): Date | null {
    if (!date) return null;
    return new Date(new Date(date).getTime() - 24 * 60 * 60 * 1000);
  }

  ngOnInit(): void {
    const now = new Date();
    const twoMonthsFromNow = new Date();
    twoMonthsFromNow.setMonth(now.getMonth() + 2);
    this.patient0 = signal(this.patient!);
    if (this.patient0() != undefined) {
      this.enCoursDeChargement0.set(true);
      this.subscriptionChargementDonneePatient = this.patientService
        .pullDetail(this.patient0()!.id!)
        .subscribe({
          next: (temp: Patient) => {
            temp.patientComplement = this.patient0()!.patientComplement;
            this.patient0.set(temp);
            this.enCoursDeChargement0.set(false);
            // if (this.patient0()?.canSign) {
            //   switch (this.activite) {
            //     case 'PPC':
            //       if (this.patient?.acceptOrdonnance()) {
            //         if (
            //           this.patient0()?.canSign &&
            //           !(
            //             this.patient0()!.prescriptionFormPrecedente
            //               ?.createdAt &&
            //             this.patient0()!.patientComplement
            //               ?.dateDernierePrescription &&
            //             this.patient0()!.prescriptionFormPrecedente!
            //               .createdAt! >=
            //               this.patient0()!.patientComplement!
            //                 .dateDernierePrescription! &&
            //             this.patient0()!.prescriptionFormPrecedente!.transmise
            //           )
            //         ) {
            //           this.onClickSignMass.emit();
            //         }
            //       } else {
            //         // pas de signature en masse en cas de DAP PDF ou DAP ordoclic
            //       }
            //       break;
            //     default:
            //       // pas de signature en masse si pas PPC
            //       break;
            //   }
            // }
          },
          error: (error) => {},
        });
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptionChargementDonneePatient) {
      this.subscriptionChargementDonneePatient.unsubscribe();
    }
  }
}
